import React from "react";
import "./styles.css";
import Button from "../button/button";

const InsuranceStatusSelector = ({ activeTab, buttons, parentClassname }) => {
  return (
    <div
      className={`insurance-status-selector-parent-container ${parentClassname}`}
    >
      {buttons?.map((btn) => {
        return (
          <Button
            key={btn?.key}
            variant="tabs"
            className="full-width-button"
            onClick={btn?.onClick}
            isActive={activeTab?.key === btn?.key}
          >
            {btn?.text}
          </Button>
        );
      })}
    </div>
  );
};

export default InsuranceStatusSelector;
